import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star } from 'lucide-react';
import { mockTestimonials } from '../mock';

export const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-green-50 to-emerald-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-6 mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            Trusted by Healthcare
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-green-700">
              {" "}Professionals
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See how leading healthcare practices are transforming their patient management and aftercare 
            with our AI-powered automation platform.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {mockTestimonials.map((testimonial) => (
            <Card key={testimonial.id} className="group hover:shadow-xl transition-all duration-300 border-0 bg-gradient-to-br from-white to-gray-50 hover:from-emerald-50 hover:to-green-50">
              <CardContent className="p-8 space-y-6">
                <div className="flex items-start space-x-4">
                  <img 
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover ring-4 ring-emerald-100"
                  />
                  <div className="flex-1">
                    <div className="flex items-center space-x-2 mb-2">
                      <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                      <div className="flex">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                        ))}
                      </div>
                    </div>
                    <p className="text-sm text-gray-600">{testimonial.title}</p>
                    <p className="text-sm font-medium text-emerald-600">{testimonial.practice}</p>
                  </div>
                </div>
                
                <blockquote className="text-gray-700 leading-relaxed italic">
                  "{testimonial.quote}"
                </blockquote>
                
                <div className="grid grid-cols-3 gap-4 pt-4 border-t border-gray-100">
                  <div className="text-center">
                    <p className="text-sm font-semibold text-emerald-600">{testimonial.metrics.metric1}</p>
                  </div>
                  <div className="text-center">
                    <p className="text-sm font-semibold text-emerald-600">{testimonial.metrics.metric2}</p>
                  </div>
                  <div className="text-center">
                    <p className="text-sm font-semibold text-emerald-600">{testimonial.metrics.metric3}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-12 border-t border-gray-200">
          <div className="text-center space-y-2">
            <div className="text-3xl font-bold text-gray-900">25K+</div>
            <div className="text-sm text-gray-600">Appointments Scheduled</div>
          </div>
          <div className="text-center space-y-2">
            <div className="text-3xl font-bold text-gray-900">8.5K+</div>
            <div className="text-sm text-gray-600">Reviews Collected</div>
          </div>
          <div className="text-center space-y-2">
            <div className="text-3xl font-bold text-gray-900">150+</div>
            <div className="text-sm text-gray-600">Practices Served</div>
          </div>
          <div className="text-center space-y-2">
            <div className="text-3xl font-bold text-gray-900">4.8★</div>
            <div className="text-sm text-gray-600">Average Rating</div>
          </div>
        </div>
      </div>
    </section>
  );
};